import { render, staticRenderFns } from "./BrandRankLine.vue?vue&type=template&id=75044062&scoped=true"
import script from "./BrandRankLine.vue?vue&type=script&lang=js"
export * from "./BrandRankLine.vue?vue&type=script&lang=js"
import style0 from "./BrandRankLine.vue?vue&type=style&index=0&id=75044062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75044062",
  null
  
)

export default component.exports